exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customAccordion img { max-height: 200px; display: block; margin: 0 auto 20px; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/image/image.component.css
// module id = ../../../../../src/app/layout/image/image.component.css
// module chunks = main